module.exports = __webpack_public_path__ + "ccef0fc24b921b2edb2b53d8c201bb74.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/reports.png
// module id = 601
// module chunks = 0